import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useHealth } from '@/hooks/useHealth';

/**
 * If the API is confirmed unreachable (after retries), send the user to the
 * standalone /status page. Lives inside the main Layout only, so it never runs
 * on /status itself (no redirect loop). Renders nothing.
 */
export function ApiHealthGate() {
  const { isError, isLoading } = useHealth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && isError && location.pathname !== '/status') {
      navigate('/status', { replace: true });
    }
  }, [isError, isLoading, location.pathname, navigate]);

  return null;
}
